import React, { Component } from 'react';

class Footer extends Component {

    getFullYear() {
        var today = new Date();
        return (today.getFullYear())
    }

    render() {
        return (
              <footer className="app-footer">
                <a  href="http://assetvault.co.nz">Asset Vault Ltd</a> &copy; {this.getFullYear()}
              </footer>
        )
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/App/views/components/Footer/Footer.js